import { NgModule } from '@angular/core';
import { NeighborChangeComponent } from './neighbor-change.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ComunModule } from '../../../comun.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ChangeType } from '../../../enums/change-type.enum';


const routes: Routes = [
  {
    path: '',
    component: NeighborChangeComponent,
    data: { tipoCambio: ChangeType.NeighborDelivery },
    outlet: 'entregaVecino'
  }
]
export const routing = RouterModule.forChild(routes)
@NgModule({
  imports: [
    FormsModule,
    ComunModule,
    routing,
    TooltipModule
  ],
  declarations: [NeighborChangeComponent]
})
export class NeighborChangeModule { }
